export default __webpack_public_path__ + "static/media/Girdle of the Haunter in the Dark.87e6742e.jpg";